import { jsx as o, jsxs as p } from "react/jsx-runtime";
import { ArrowDownIcon as c, CheckIcon as u } from "@systemeio/ui/icons";
import { Popover as f, Tooltip as d, FormInputUrl as h } from "@systemeio/ui";
import { isValidUrl as b } from "@systemeio/util";
import { useState as g } from "react";
import { ToolbarButton as x } from "../../components/content-controls/toolbar-button.mjs";
import { TOOLTIP_STYLES as N, getToolbarIconClassName as l } from "../../constants/default-styles.mjs";
import { useTranslation as i } from "../../i18n.mjs";
import { twMerge as k } from "tailwind-merge";
function U({ isDisabled: r, handleSetImage: t }) {
  const { t: a } = i();
  return /* @__PURE__ */ o(
    f,
    {
      disabled: r,
      anchor: "bottom",
      wrapperClassName: "group px-1.5",
      label: /* @__PURE__ */ o(v, { handleSetImage: t, isDisabled: r }),
      children: (e) => /* @__PURE__ */ o(
        d,
        {
          disabled: r,
          className: "content-center",
          label: a("image_via_link"),
          wrapperClassName: "h-full",
          ...N,
          children: /* @__PURE__ */ o(
            c,
            {
              className: k(
                l(r),
                "transition-transform duration-200 ease-linear ",
                "main-transition-colors h-3.5 w-3.5",
                r ? "stroke-text-secondary" : "stroke-text-primary group-hover:stroke-brand-primary",
                e && "rotate-180"
              )
            }
          )
        }
      )
    }
  );
}
function v({ handleSetImage: r, isDisabled: t }) {
  const { t: a } = i(), [e, s] = g(""), m = t || !e || !b(e);
  return /* @__PURE__ */ p("form", { onSubmit: (n) => n.preventDefault(), className: "flex items-end", children: [
    /* @__PURE__ */ o(
      h,
      {
        inputClassName: "min-w-[200px]",
        placeholder: "example.com/image.png",
        disabled: t,
        label: a("image_insert_via_link"),
        value: e,
        onChange: (n) => s(n)
      }
    ),
    /* @__PURE__ */ o(
      x,
      {
        disabled: m,
        type: "submit",
        onClick: () => r(e),
        className: "mb-[5px]",
        children: /* @__PURE__ */ o(u, { className: l(m) })
      }
    )
  ] });
}
export {
  U as InsertImageViaLink
};
